import Clipboard from 'clipboard';

interface CustomDocument extends Document {
  documentMode?: number;
}
declare let document: CustomDocument;

type formatType = (text: string, footer?: string) => string;
export const formatCopy: formatType = (text, footer = '') =>
  `« ${text} »\n\n${footer}`;

const formatForIe: formatType = (text) => text.replace(/\n/gi, '<br /><br />');
const formatEdge: formatType = (text) => text.replace(/\n/gi, '\n\n');

const isIe = (): boolean => {
  if (/* @cc_on!@ */ false || !!document.documentMode) return true;
  return false;
};

const isEdge = (): boolean => {
  if (window.navigator.userAgent.indexOf('Edge') > -1) return true;
  return false;
};

type copyType = (text: string) => Promise<string>;
export const copy: copyType = (text) =>
  new Promise((resolve, reject) => {
    const div = document.createElement('div');
    div.innerHTML = formatForIe(text);

    const clipboard = new Clipboard(div, {
      text: (target) => {
        if (isIe() && target.textContent) return target.textContent;
        if (isEdge()) return formatEdge(text);
        return text;
      },
    });

    clipboard.on('success', () => {
      clipboard.destroy();
      resolve();
    });

    clipboard.on('error', (e) => reject(e));

    div.click();
  });
